import { createEntityMutation } from '../../createEntityMutation';
import {
  UserDefinedFieldValuesService,
  type Wealthlane_CustomerService_Dtos_UserDefinedFieldValues_UpdateUserDefinedFieldValuesDto,
} from '@wealthlane/api-services/wealthlane-customer-service';

export const usePutUserDefinedFieldValues = createEntityMutation<
  Wealthlane_CustomerService_Dtos_UserDefinedFieldValues_UpdateUserDefinedFieldValuesDto[],
  Wealthlane_CustomerService_Dtos_UserDefinedFieldValues_UpdateUserDefinedFieldValuesDto[]
>({
  mutationFn: (payload) =>
    UserDefinedFieldValuesService.putApiCustomerApiAppUserDefinedFieldValuesUserDefinedFieldValues(
      payload,
    ),
  silent: true,
});
